import React, { useEffect, useMemo } from 'react'
import _ from 'lodash'
import { LockedGrid, Grid as UnlockedGrid, Grid, Panel, ToolBar, SearchField, Container, FieldSet, Button } from '@sencha/ext-modern'

import { renderColumn, getModel, handleItemContextMenu } from 'tyan/public/components//column'
import { getListFromValues, copyListValuesById, setListItems } from 'tyan/public/utility'
import { genFullListName, getMixedProps } from '../blockPublic'
import { setGridRowNumbersColumnWidth, preventCtrlR, innerSearchFn, doInnerSearch } from '../TyanGrid'
import Buttons from './Buttons'
import { useDelayTimer, useInstData } from 'tyan/public/hooks'

// const preventCtrlR = (e, el) => e.preventDefault()

const CheckGrid = props => {
	const { config: {
		that, changedValues: oldChangedValues, defaultStyle,
		field: {
			itemsValues = {}, value = [], _fieldsetName: fieldsetName, list: listConf, name: _name, ignore = [], selectableField,
			onSearch: outerSearchFn, searchStamp,
			innerSearch, // 内部搜索，有内部搜索时，使用内部通用函数进行前台搜索，过滤
			searchMode = 1/* 1:只有搜索框；2:只有列过滤；3：二者皆有（无列过滤时如果在列项上有配置，则列项上有过滤）*/,
			label, columns, sort, contextmenu, onDoubleTap, buttons, hideHeaders = undefined,
			buttonsDocked = 'top', searchDocked = 'top', summary = null,
			lockable = false,
			...field
		}
	} } = props

	const onSearch = innerSearch ? innerSearchFn : outerSearchFn
	const fullFieldName = genFullListName(listConf, _name)

	const { me, setState } = useInstData(props, useMemo(() => ({
		state: {},
		oldList: null,
		oldColumns: columns,
		store: null,
		searchStamp: undefined,
		tmrSearch: null,
		searchString: '',
		lastSearchString: '',
		filterChoices: {},  // 给column 保存当前filter choice使用{'编号':'等于'}
		filter: {},
		lastFilter: {}
	}), []))


	// console.log('render:', value, (that.state.changedValuesBasic||{})['_checkgrid-added'])
	if (me.searchStamp != searchStamp) {
		me.searchStamp = searchStamp
		me.tmrSearch = null
		me.searchString = ''
		me.lastSearchString = ''
		me.filter = {}
		me.lastFilter = {}
	}

	const getSelectedIds = () => {
		const { grid } = me
		return grid ? grid.getSelections().filter(r => selectableField ? r.data._caledSelectable : true).map(r => r.id) : []
	}

	const { doDelay: delayHandleSelect } = useDelayTimer(300)
	const handleSelect = () => {
		const doHandleSelect = () => {
			let selectedIds = getSelectedIds()
			// console.log('handleSelect:', _.sortBy(selectedIds), _.sortBy(value))
			if (_.isEqual(_.sortBy(selectedIds), _.sortBy(value))) return

			const { map } = getListFromValues(fullFieldName, itemsValues, {})
			selectedIds = selectedIds.filter(id => map[id])
			const values = selectedIds.map(id => map[id])
			setListItems(that, fieldsetName, fullFieldName, selectedIds, values)
		}

		delayHandleSelect(doHandleSelect)
	}

	const setSelected = () => {
		const { grid } = me
		const selectedIds = getSelectedIds()
		// console.log('setSelect:', _.sortBy(selectedIds), _.sortBy(value))
		if (_.isEqual(_.sortBy(selectedIds), _.sortBy(value))) return
		const selected = grid.store.data.items.filter(item => value.includes(item.id))
		// console.log('selected:', selected, selectedIds, value, grid.store.data.items, that)

		grid.suspendEvents(true)
		const selectable = grid.getSelectable()
		selectable.select(selected)
		grid.resumeEvents(true)
	}

	const handleStoreChange = (grid, store) => {
		// console.log('store change')
		grid && store && handleSelect(grid)
	}


	const handleColumnSort = (grid, column, direction) => {
		me.sort = [{ property: column.config.dataIndex, direction }]
	}

	const trySearch = () => {
		const doSearch = () => {
			// const { field: { onSearch } } = me.props.config

			me.tmrSearch && (clearTimeout(me.tmrSearch), me.tmrSearch = null)

			me.lastSearchString = me.searchString
			me.lastFilter = _.cloneDeep(me.filter)

			onSearch && onSearch(me.searchString, me.filter, setState)
		}

		me.tmrSearch && (clearTimeout(me.tmrSearch), me.tmrSearch = null);

		true && (me.searchString !== me.lastSearchString || !_.isEqual(me.filter, me.lastFilter)) && (me.tmrSearch = setTimeout(doSearch, 1000))
	}

	const handleSearch = (obj, newValue) => {
		me.searchString = newValue

		trySearch();
	}

	useEffect(() => () => { clearTimeout(me.tmrSearch) }, [])

	useEffect(() => {
		const { grid } = me
		// grid.suspendEvents(true)
		setSelected()
		// grid.resumeEvents(true)
		setGridRowNumbersColumnWidth(grid)
	})


	const changedValues = { ...oldChangedValues }
	const { props: fieldProps } = getMixedProps('_checkgrid', [defaultStyle, field])
	// const { } = field
	!label && (fieldProps.padding = '5px 0px 5px 0px')
	// const initIds = ignore.concat(initValues[`${name}`] || [])
	// const addedIds = changedValues[`${name}-added`] || []

	// 计算 list, me.store
	const { list, store } = (() => {
		const { list: listSource } = getListFromValues(fullFieldName, itemsValues, {})

		// 从选择数据中去除ignore中存在的记录
		let list = listSource.filter(o => !ignore.includes(o.id))

		// 如果前台搜索，过滤数据
		innerSearch && (list = doInnerSearch(list, me))

		// 生成可选择条件字段
		const modelPrevProps = { fields: [] }
		selectableField && modelPrevProps.fields.push({
			name: '_caledSelectable',
			calculate: typeof selectableField === 'function' ? selectableField : data => data[selectableField]
		})

		// 生成store
		if (!_.isEqual(list, me.oldList) /* || !_.isEqual(columns, me.oldColumns) */) {
			me.oldList = _.cloneDeep(list)
			me.oldColumns = columns

			const store = me.store = new Ext.data.Store({ model: getModel(columns, modelPrevProps), data: _.cloneDeep(list) })

			!me.sort && sort && (me.sort = Array.isArray(sort) ? sort : [sort])
			const sortConfig = me.sort || []
			sortConfig.length && store && store.sort(sortConfig)
		}

		return { list }
	})()


	const { compHeightProps, optGridProps } = (() => {

		const { rowNumbers = false, columnLines = false, minRows = 0, maxRows = Number.MAX_VALUE, height } = field

		// 计算高度，如果设置了height，则忽略 maxRows（Number.MAX_VALUE)
		const compHeightProps = {}
		const optGridProps = {}

		optGridProps.minHeight = (hideHeaders ? 2 : 45) + 41 * minRows - 2
		height
			? optGridProps.flex = 1
			: optGridProps.maxHeight = (hideHeaders ? 2 : 45) + 41 * maxRows - 2

		rowNumbers && (optGridProps.rowNumbers = true) //{ width: `${me.store ? (32 + Math.floor(Math.log10(me.store.data.length || 1)) * 7) : 32}px` })
		// rowNumbers && (optGridProps.rowNumbers = { width: '40px' })
		columnLines && (optGridProps.columnLines = true)
		hideHeaders && (optGridProps.hideHeaders = true)

		contextmenu && (optGridProps.onChildContextMenu = optGridProps.onChildLongPress = (grid, { record, event }) => handleItemContextMenu(contextmenu, grid, record, event, that))
		onDoubleTap && (optGridProps.onChildDoubleTap = (grid, location) => onDoubleTap(location.record.data, location.record, grid, that, location))
		columns.find(col => col._richtext != undefined) && (optGridProps.variableHeights = true)

		return { compHeightProps, optGridProps }
	})()

	return <FieldSet title={label} {...fieldProps} layout='vbox' {...compHeightProps} errorTarget={undefined}>
		<Grid ref={ref => ref && (/* window.grid =  */me.grid = ref.cmp)} {...optGridProps}
			store={me.store}
			shadow={false} width="100%" scrollable style={{ borderStyle: 'solid', borderWidth: '1px', borderColor: '#e2e2e2' }}
			itemConfig={{ bind: {}, viewModel: {} }}
			selectable={{
				checkbox: true, drag: true,/*  extensible: 'both',  */mode: 'multi', rows: true, cells: false, columns: false, deselectable: true,
				...(selectableField && { checkboxDefaults: { cell: { bind: { hidden: '{!record._caledSelectable}' }, hideMode: 'visibility' } } } || {})
			}}
			onSelect={handleSelect}
			onDeselect={handleSelect}
			onColumnSort={handleColumnSort}
			onStoreChange={handleStoreChange}
		>
			{
				columns.map(({ search, filter, ...column }, key) => renderColumn({
					filter: onSearch && searchMode & 2 ? filter : undefined,
					...column,
					filterProp: me.filter, filterChoices: me.filterChoices, onFilterChange: trySearch
				}, key, that))
			}
		</Grid>
		{buttons && (!((onSearch && searchMode & 1) || summary) || searchDocked != buttonsDocked) &&
			<ToolBar docked={buttonsDocked} ui="app-transparent-toolbar" shadow={false} margin="0 0 0 0" padding="0 0 0 0" layout={{ type: 'hbox', align: 'center' }}>
				<Buttons docked={buttonsDocked} buttons={buttons} />
			</ToolBar>
		}
		{((onSearch && searchMode & 1) || summary) &&
			<ToolBar docked={searchDocked} ui="app-transparent-toolbar" shadow={false} margin="0 0 0 0" padding="0 0 0 0" layout={{ type: 'hbox', align: 'center' }}>
				{onSearch && (searchMode & 1) !== 0 && <SearchField align="right" ui="solo ks-search-right-trigger" width="280"
					value={me.searchString}
					placeholder={`搜索 ...`}
					onChange={handleSearch}
					margin="0 10 0 0"
					keyMap={{ 'Ctrl+R': { handler: preventCtrlR } }}
				/> || null}
				{(summary || (summary != false && onSearch && (searchMode & 1) !== 0)) && <Panel padding="9 20 9 20" docked='right' layout={{ type: 'hbox', align: 'end' }}>
					<div>{`共 ${list.length} 条记录，已选择 ${value.length} 条记录`}</div>
				</Panel> || null}
				{buttons && buttonsDocked == searchDocked && <Buttons docked={buttonsDocked} buttons={buttons} /> || null}
			</ToolBar> || null
		}
	</FieldSet >
}


export default CheckGrid